import { DaoService } from "./DaoService";

export class EtapeModeleService extends DaoService {
	static CLASS_NAME = "App\\Models\\EtapeModele";

	static getInstance() {
		return super.getInstance("etapemodele");
	}

	all() {
		return EtapeModeleService.get(`${this.prefix}/all`);
	}

	search(data) {
		return EtapeModeleService.post(`${this.prefix}/search`, data);
	}

	updateOrder(data) {
		return EtapeModeleService.post(`${this.prefix}/update-order`, data);
	}
}
